var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortAzAlphaIcon = function SvgSortAzAlphaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.318 10.818H4L6.008 5h1.586l2.005 5.818H8.281L6.824 6.33h-.046zm-.082-2.287h3.113v.96H5.236zm-.983 10.287v-.73l2.903-4.074H4.247V13h4.455v.73l-2.907 4.074h2.912v1.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.13 5.818a.68.68 0 0 1 .68-.68h6.375a.68.68 0 1 1 0 1.36H12.81a.68.68 0 0 1-.68-.68m0 5.834a.68.68 0 0 1 .68-.68h4.125a.68.68 0 0 1 0 1.36H12.81a.68.68 0 0 1-.68-.68m0 5.833a.68.68 0 0 1 .68-.68h1.875a.68.68 0 0 1 0 1.36H12.81a.68.68 0 0 1-.68-.68"
  }))));
};
export default SvgSortAzAlphaIcon;